export type TemplateDocument = {
  id: string; name: string; description?: string; category?: string;
  schema_version: 2; width: number; height: number; canvas: Record<string, any>;
  thumbnail?: string; scope?: 'public' | 'private'; owner_id?: number;
  revision?: string; editable?: boolean; legacy?: boolean;
};
export const PRESETS = [
  { name: '小红书 · 3:4', w: 1080, h: 1440 },
  { name: '手机海报 · 9:16', w: 1080, h: 1920 },
  { name: '方形卡片 · 1:1', w: 1080, h: 1080 },
  { name: '横版演示 · 16:9', w: 1920, h: 1080 },
  { name: '公众号封面 · 2:1', w: 1920, h: 960 },
];
export function blankTemplate(): TemplateDocument {
  return { id: `tpl_${crypto.randomUUID().replaceAll('-', '')}`, name: '未命名模板', schema_version: 2,
    width: 1080, height: 1440, scope: 'private', canvas: { objects: [], background: '#ffffff' } };
}
